import {
  createModifier as publicCreateModifier,
  getModifier as publicGetModifier,
  listModifiers as publicListModifiers,
  updateModifier as publicUpdateModifier,
  bulkCreateModifiers as publicBulkCreateModifiers,
  bulkUpdateModifiers as publicBulkUpdateModifiers,
  deleteModifier as publicDeleteModifier,
  queryModifiers as publicQueryModifiers,
  typedQueryModifiers as publicTypedQueryModifiers,
  countModifiers as publicCountModifiers,
  bulkDeleteModifiers as publicBulkDeleteModifiers,
} from './restaurants-menus-v1-item-modifier-item-modifiers.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ModifierQuery,
  ModifiersQueryBuilder,
  typedQueryModifiers as universalTypedQueryModifiers,
} from './restaurants-menus-v1-item-modifier-item-modifiers.universal.js';
import { onItemModifierCreated as publicOnItemModifierCreated } from './restaurants-menus-v1-item-modifier-item-modifiers.public.js';
import { onItemModifierDeleted as publicOnItemModifierDeleted } from './restaurants-menus-v1-item-modifier-item-modifiers.public.js';
import { onItemModifierUpdated as publicOnItemModifierUpdated } from './restaurants-menus-v1-item-modifier-item-modifiers.public.js';

function customQueryModifiers(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryModifiers(httpClient)(),
    typedQueryFunction: (query: ModifierQuery) =>
      publicTypedQueryModifiers(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ModifiersQueryBuilder;
  function overloadedQuery(
    query: ModifierQuery
  ): ReturnType<typeof universalTypedQueryModifiers>;
  function overloadedQuery(query?: ModifierQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createModifier: MaybeContext<
  BuildRESTFunction<typeof publicCreateModifier> & typeof publicCreateModifier
> = /*#__PURE__*/ createRESTModule(publicCreateModifier);
export const getModifier: MaybeContext<
  BuildRESTFunction<typeof publicGetModifier> & typeof publicGetModifier
> = /*#__PURE__*/ createRESTModule(publicGetModifier);
export const listModifiers: MaybeContext<
  BuildRESTFunction<typeof publicListModifiers> & typeof publicListModifiers
> = /*#__PURE__*/ createRESTModule(publicListModifiers);
export const updateModifier: MaybeContext<
  BuildRESTFunction<typeof publicUpdateModifier> & typeof publicUpdateModifier
> = /*#__PURE__*/ createRESTModule(publicUpdateModifier);
export const bulkCreateModifiers: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateModifiers> &
    typeof publicBulkCreateModifiers
> = /*#__PURE__*/ createRESTModule(publicBulkCreateModifiers);
export const bulkUpdateModifiers: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateModifiers> &
    typeof publicBulkUpdateModifiers
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateModifiers);
export const deleteModifier: MaybeContext<
  BuildRESTFunction<typeof publicDeleteModifier> & typeof publicDeleteModifier
> = /*#__PURE__*/ createRESTModule(publicDeleteModifier);
export const countModifiers: MaybeContext<
  BuildRESTFunction<typeof publicCountModifiers> & typeof publicCountModifiers
> = /*#__PURE__*/ createRESTModule(publicCountModifiers);
export const bulkDeleteModifiers: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteModifiers> &
    typeof publicBulkDeleteModifiers
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteModifiers);
export const queryModifiers: MaybeContext<
  BuildRESTFunction<typeof customQueryModifiers> & typeof customQueryModifiers
> = /*#__PURE__*/ createRESTModule(customQueryModifiers);
/** */
export const onItemModifierCreated: BuildEventDefinition<
  typeof publicOnItemModifierCreated
> &
  typeof publicOnItemModifierCreated = createEventModule(
  publicOnItemModifierCreated
);
/** */
export const onItemModifierDeleted: BuildEventDefinition<
  typeof publicOnItemModifierDeleted
> &
  typeof publicOnItemModifierDeleted = createEventModule(
  publicOnItemModifierDeleted
);
/** */
export const onItemModifierUpdated: BuildEventDefinition<
  typeof publicOnItemModifierUpdated
> &
  typeof publicOnItemModifierUpdated = createEventModule(
  publicOnItemModifierUpdated
);

export {
  SortOrder,
  WebhookIdentityType,
} from './restaurants-menus-v1-item-modifier-item-modifiers.universal.js';
export {
  Modifier,
  ExtendedFields,
  ExternalReferenceInfo,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateModifierRequest,
  CreateModifierResponse,
  GetModifierRequest,
  GetModifierResponse,
  ListModifiersRequest,
  CursorPaging,
  ListModifiersResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateModifierRequest,
  UpdateModifierResponse,
  BulkCreateModifiersRequest,
  BulkCreateModifiersResponse,
  BulkCreateModifierResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkUpdateModifiersRequest,
  MaskedModifier,
  BulkUpdateModifiersResponse,
  BulkUpdateModifierResult,
  DeleteModifierRequest,
  DeleteModifierResponse,
  QueryModifiersRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  QueryModifiersResponse,
  CountModifiersRequest,
  CountModifiersResponse,
  BulkDeleteModifiersRequest,
  BulkDeleteModifiersResponse,
  BulkDeleteModifiersResult,
  CloneModifiersRequest,
  CloneModifiersResponse,
  BulkUpdateBusinessLocationIdsRequest,
  BulkUpdateBusinessLocationIdsResponse,
  BulkUpdateBusinessLocationIdsResponseBulkItemResult,
  BulkUpdateBusinessLocationIdsPerEntityRequest,
  ModifierIdLocationIds,
  BulkUpdateBusinessLocationIdsPerEntityResponse,
  BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult,
  BulkUpdateAttachedToOrphanItemRequest,
  ModifierIdAttachedToOrphanItem,
  BulkUpdateAttachedToOrphanItemResponse,
  BulkItemResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  SyncContentToMultilingualRequest,
  SyncContentToMultilingualResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ItemModifierCreatedEnvelope,
  ItemModifierDeletedEnvelope,
  ItemModifierUpdatedEnvelope,
  ListModifiersOptions,
  UpdateModifier,
  BulkCreateModifiersOptions,
  BulkUpdateModifiersOptions,
  ModifiersQueryResult,
  ModifiersQueryBuilder,
  ModifierQuerySpec,
  CountModifiersOptions,
} from './restaurants-menus-v1-item-modifier-item-modifiers.universal.js';
export { utils } from './restaurants-menus-v1-item-modifier-item-modifiers.universal.js';
export {
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CountModifiersApplicationErrors,
  CommonQueryWithEntityContext,
  ModifierQuery,
} from './restaurants-menus-v1-item-modifier-item-modifiers.universal.js';
